"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMockFactory = void 0;
const user_model_1 = require("../models/user.model");
const testing_1 = require("@engineering11/testing");
class UserMockFactory extends testing_1.BaseMockFactory {
    defaultData() {
        const firstName = (0, testing_1.fakeFirstName)();
        const lastName = (0, testing_1.fakeLastName)();
        const isDisabled = (0, testing_1.fakeBoolean)(0.1);
        const disabledDate = isDisabled ? (0, testing_1.fakeDateBetween)(new Date('2020'), new Date()) : undefined;
        return {
            id: (0, testing_1.fakeId)(),
            email: (0, testing_1.fakeEmail)(firstName, lastName, 'cnect.dev').toLowerCase(),
            firstName: firstName,
            lastName: lastName,
            customerKey: (0, testing_1.fakeId)(),
            roles: [],
            termsVersionAccepted: (0, testing_1.fakeNumber)(1, 2),
            authId: (0, testing_1.fakeId)(),
            authTenant: 'authTenant',
            bootstrapTenantKey: 'fakeBootstrap',
            userType: (0, testing_1.randomEnum)(user_model_1.UserType),
            phoneNumber: (0, testing_1.fakePhoneNumber)(),
            defaultLanguageCode: 'en-US',
            displayName: `${firstName} ${lastName}`,
            photoURL: (0, testing_1.fakeProfilePhoto)(),
            disabled: disabledDate,
            isDisabled: isDisabled,
        };
    }
}
exports.UserMockFactory = UserMockFactory;
